import Divider from '@mui/material/Divider'
import Box, { BoxProps } from '@mui/material/Box'

interface Props extends BoxProps {
  offline?: boolean
  color?: string
}

export default function DiagramLink({ offline, color, ...props }: Props) {
  return (
    <Box
      {...props}
      sx={[{
        flexGrow: 1,
        marginBottom: 2.5,
        marginX: -2
      }, ...(Array.isArray(props.sx) ? props.sx : [props.sx])]}>
      <Divider
        sx={{
          borderStyle: offline ? 'dashed' : 'solid',
          borderColor: color || (offline ? undefined : 'contrast.medium'),
        }}
      ></Divider>
    </Box>
  )
}
